import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PhoneNumberWithPrefixRequest } from '@web/shared/module/dictionary';
import { AdminShipmentSizeType } from '../../enums/admin-shipment-size-type';
import { dateSerializer } from '@web/common';
import { AdminOrderShipmentItemRequest } from './admin-order-shipment-item.request';

@jsonObject
export class AdminOrderShippingAddressUpdateRequest {
  @jsonMember(String)
  public readonly firstName!: string;

  @jsonMember(String)
  public readonly lastName!: string;

  @jsonMember(PhoneNumberWithPrefixRequest)
  public readonly phone!: PhoneNumberWithPrefixRequest;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly countryId!: Guid;

  @jsonMember(String)
  public readonly streetLine1!: string;

  @jsonMember(String)
  public readonly streetLine2?: Nillable<string>;

  @jsonMember(String)
  public readonly postCode!: string;

  @jsonMember(String)
  public readonly city!: string;

  @jsonMember(String)
  public readonly state?: Nillable<string>;

  @jsonMember(String)
  public readonly companyName?: Nillable<string>;

  @jsonMember(String)
  public readonly shippingMethod?: Nillable<Guid>;

  @jsonMember(String)
  public readonly shippingPoint?: Nillable<string>;

  @jsonMember(String)
  public readonly packageSize!: AdminShipmentSizeType;

  @jsonMember(Date, { serializer: dateSerializer() })
  public readonly scheduledShippingDate!: Date;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly boxes?: Nillable<AdminOrderShipmentItemRequest[]>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly products?: Nillable<AdminOrderShipmentItemRequest[]>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly cosmetics?: Nillable<AdminOrderShipmentItemRequest[]>;

  public constructor(
    private readonly data: {
      city: string;
      companyName?: Nillable<string>;
      countryId: Guid;
      email: string;
      firstName: string;
      lastName: string;
      phone: PhoneNumberWithPrefixRequest;
      postCode: string;
      state?: Nillable<string>;
      streetLine1: string;
      streetLine2?: Nillable<string>;
      shippingMethod?: Nillable<Guid>;
      shippingPoint?: Nillable<string>;
      packageSize: AdminShipmentSizeType;
      scheduledShippingDate: Date;
      comment?: Nillable<string>;
      boxes?: Nillable<AdminOrderShipmentItemRequest[]>;
      products?: Nillable<AdminOrderShipmentItemRequest[]>;
      cosmetics?: Nillable<AdminOrderShipmentItemRequest[]>;
    },
  ) {
    this.city = this.data.city;
    this.companyName = this.data.companyName;
    this.countryId = this.data.countryId;
    this.email = this.data.email;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.phone = this.data.phone;
    this.postCode = this.data.postCode;
    this.state = this.data.state;
    this.streetLine1 = this.data.streetLine1;
    this.streetLine2 = this.data.streetLine2;
    this.shippingMethod = this.data.shippingMethod;
    this.shippingPoint = this.data.shippingPoint;
    this.packageSize = this.data.packageSize;
    this.scheduledShippingDate = this.data.scheduledShippingDate;
    this.comment = this.data.comment;
    this.boxes = this.data.boxes;
    this.products = this.data.products;
    this.cosmetics = this.data.cosmetics;
  }
}
